import easyfyAxios from '@shared/easyfy.axios';

export const GetOptionsSelectorFlyout = async (
  searchProductId: string,
  attributeKey: string,
  isVariant: boolean,
  selectedVariant: string | null,
  isProductSeries: boolean
): Promise<any> => {
  if (isProductSeries) {
    return await easyfyAxios.get(`/api/optionsflyout?handler=productSeriesFlyout&productSeriesId=${searchProductId}`);
  }

  const params = new URLSearchParams({
    searchProductId,
    attributeKey,
    isVariant: String(isVariant),
    ...(selectedVariant ? { selectedVariant } : {}),
  });
  return await easyfyAxios.get(`/api/optionsflyout?${params}`);
};
